export const replace = (search: string | RegExp) => (replace: string) => (s: string) =>
    s.replace(search, replace);

export const replaceLastCharWith = replace(/.$/gi);
